import styled from 'styled-components';

export const ChartWrapper = styled.div`
  position: relative;
  width: 150px;
  height: 150px;
  flex-shrink: 0;
  aspect-ratio: 1 / 1;
`;

export const ChartCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const CenterPercentage = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ChartNumberWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 2px;
  align-self: stretch;
`;

export const ChartNumber = styled.span`
  font-size: 30px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.5px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const ChartPercentage = styled.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const ChartTitle = styled.div`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black7};
  text-align: center;
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;
